import React from "react";
import ChequeContractStep1 from "../../components/ChequeContract/Add/ChequeContractStep1";
import ChequeContractStep3 from "../../components/ChequeContract/Add/ChequeContractStep3";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";

const ChequeContractAddPage = (props) => {
  const [step, setStep] = React.useState(1);
  const [firstCheque, setFirstCheque] = React.useState(
    props.isEdit ? props.data.cheques_first : [],
  );
  const [secondCheque, setSecondCheque] = React.useState(
    props.isEdit ? props.data.cheques_second : [],
  );
  const [percent, setPercent] = React.useState(
    props.isEdit ? props.data.ratio : null,
  );
  const [originDate, setOriginDate] = React.useState(
    props.isEdit ? props.data.origin_date : new Date(),
  );

  // const showUnknown = () => {
  //     return <Wrapper>
  //         نامشخص
  //     </Wrapper>
  // }

  // let showDetail = showUnknown();

  // if(step === 1)
  //     showDetail =
  // else if (step === 2)
  //     showDetail = <ChequeContractStep2
  //         firstCheque={secondCheque}
  //         setFirstCheque={setSecondCheque}
  //         percent={percent}
  //         setPercent={setPercent}
  //         setStep={setStep}
  //         step={step}
  //     />
  // else if (step === 3)
  //     showDetail = <ChequeContractStep3
  //         firstCheque={firstCheque}
  //         setFirstCheque={setFirstCheque}
  //         secondCheque={secondCheque}
  //         setSecondCheque={setSecondCheque}
  //         isEdit={props.isEdit}
  //         percent={percent}
  //         setPercent={setPercent}
  //         setStep={setStep}
  //         step={step}
  //         data={props.data}
  //
  //     />

  return (
    <Wrapper>
      <BreadcrumbsTemp
        title={props.isEdit ? "ویرایش خرید دین" : "افزودن خرید دین"}
        items={[
          {
            title: "خرید دین ",
            to: "/cheque-contract/list",
          },
          props.isEdit
            ? {
                title: "ویرایش خرید دین",
                to: "/cheque-contract/list",
              }
            : {
                title: "افزودن خرید دین ",
                to: "/cheque-contract/add",
              },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <ChequeContractStep1
            firstCheque={firstCheque}
            setFirstCheque={setFirstCheque}
            percent={percent}
            setPercent={setPercent}
            setStep={setStep}
            step={step}
            originDate={originDate}
            setOriginDate={setOriginDate}
          />
          <ChequeContractStep3
            firstCheque={firstCheque}
            setFirstCheque={setFirstCheque}
            secondCheque={secondCheque}
            setSecondCheque={setSecondCheque}
            isEdit={props.isEdit}
            percent={percent}
            setPercent={setPercent}
            originDate={originDate}
            setOriginDate={setOriginDate}
            setStep={setStep}
            step={step}
            data={props.data}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ChequeContractAddPage;
